import {
	SetNotificationDocumentReportMutation,
	SetNotificationRecipientsMutation,
	SetNotificationSendChoiceMutation,
	SetNotificationTextRecipientsMutation
} from "~/gql/mutations/notificationOverrides.generated";
import {
	GetCustomerNotificationSettingsQuery,
	GetOrderNotificationSettingsQuery
} from "~/gql/queries/notificationSettings.generated";

export const notificationOverridesEndpoints = {
	GetCustomerNotificationSettings: {
		providesTags: ["NotificationSettings"] as AddTagTypes,
		transformResponse: (res: GetCustomerNotificationSettingsQuery) => res
	},
	GetOrderNotificationSettings: {
		providesTags: ["NotificationSettings"] as AddTagTypes,
		transformResponse: (res: GetOrderNotificationSettingsQuery) => res
	},
	SetNotificationDocumentReport: {
		invalidatesTags: ["NotificationSettings", "Orders"] as AddTagTypes,
		transformResponse: (res: SetNotificationDocumentReportMutation) => res
	},
	SetNotificationRecipients: {
		invalidatesTags: ["NotificationSettings"] as AddTagTypes,
		transformResponse: (res: SetNotificationRecipientsMutation) => res
	},
	SetNotificationSendChoice: {
		invalidatesTags: ["NotificationSettings"] as AddTagTypes,
		transformResponse: (res: SetNotificationSendChoiceMutation) => res
	},
	SetNotificationTextRecipients: {
		invalidatesTags: ["NotificationSettings"] as AddTagTypes,
		transformResponse: (res: SetNotificationTextRecipientsMutation) => res
	}
};
